import React from "react";
import Layout from "../layouts/index";
import Booking from "../screens/Vision/Vision";
import Toaster from "../components/Toaster";

const Vision = () => {
  return (
    <Layout>
      <Toaster>
        <Booking />
      </Toaster>
    </Layout>
  );
};

export default Vision;
